import Resource from '../utils/resource'

export default new Resource('/Feeds', {})
